import script from "./page-1-b5.vue?vue&type=script&setup=true&lang=js"
export * from "./page-1-b5.vue?vue&type=script&setup=true&lang=js"

import "./page-1-b5.vue?vue&type=style&index=0&id=00b641cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b641cc"]])

export default __exports__